import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ThemeProvider } from './components/ThemeProvider';
import { captureInstallPrompt } from './lib/installPrompt';
import { registerPwa } from './lib/pwa';
import { initSentry } from './lib/sentry';
import './index.css';

initSentry();
registerPwa();
captureInstallPrompt();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root is missing from index.html.');
}

createRoot(rootElement).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
);
